<template>
  <div class="barcode-container" :style="barcodeTextStyle">
    <!-- {{conf}}-->
    <!-- {{textStyle}}  -->
    <div v-if="conf.textPosition == '1'" class="barcodeText" :style="textStyle">
      {{ conf.text }}
    </div>
    <image-box
      :key="conf.componentId"
      :src="conf.colorFlag && conf.colorFlag == 'black' ? barCode : barCode1"
      :style="barcodeStyle"
      :default-img="
        conf.colorFlag && conf.colorFlag == 'black' ? barCode : barCode1
      "
      v-if="conf.directionFlag != 1"
    />
    <image-box
      :key="conf.componentId"
      :src="conf.colorFlag && conf.colorFlag == 'black' ? barCode2 : barCode3"
      :style="barcodeVerticalStyle"
      :default-img="
        conf.colorFlag && conf.colorFlag == 'black' ? barCode2 : barCode3
      "
      v-if="conf.directionFlag == 1"
    />
    <div v-if="conf.textPosition == '2'" class="barcodeText" :style="textStyle">
      {{ conf.text }}
    </div>
  </div>
</template>

<script>
import ImageBox from "../../tumeng-Image/Image.vue";
import barCode from "../../../assets/imgs/barCode.png";
import barCode1 from "../../../assets/imgs/barCode1.png";
import barCode2 from "../../../assets/imgs/barCode2.png";
import barCode3 from "../../../assets/imgs/barCode3.png";

export default {
  name: "TumengBARCode",
  components: {
    ImageBox,
  },
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      barCode,
      barCode1,
      barCode2,
      barCode3,
      showIdx: 0,
      hasLoadError: false,
    };
  },
  computed: {
    barcodeTextStyle() {
      return {
        backgroundColor: this.conf.bgColor,
        height: this.conf.hight + "px",
      };
    },
    textStyle() {
      return {
        color: this.conf.fontColor,
        fontFamily: this.conf.textStyle.font,
        fontSize: this.conf.textStyle.fontSize + 'px',
        height: this.conf.textStyle.lineHeight + "px",
        lineHeight: this.conf.textStyle.lineHeight + "px",
      };
    },
    barcodeStyle() {
      return {
        
        // opacity: 1 - this.conf.transparency,
        // borderRadius: this.conf.borderRadius + "%",
        // overflow: "hidden",
        width: this.conf.width + "px",
        height: this.conf.codeHeight ? this.conf.codeHeight + "px" : "auto",
      };
    },

    barcodeVerticalStyle() {
      return {
        // transform: 'rotate(90deg)',
        // transformOrigin: 'top left',
        // opacity: 1 - this.conf.transparency,
        // borderRadius: this.conf.borderRadius + "%",
        // overflow: "hidden",
        width: this.conf.width + "px",
        height: this.conf.height + "px",
      };
    },
    
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.barcode-container {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // width: 100%;
  // height: 100%;
  text-align: center;
  ::v-deep .image-box img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
